import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  private startYear = 2015;
  public date: string;

  constructor() { }

  ngOnInit() {
    const currentYear: number = new Date().getFullYear();
    this.date = this.startYear === currentYear ? `${currentYear}` : `${this.startYear},${currentYear}`;
  }
}
